import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49edc930"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "colour-picker" }
const _hoisted_2 = { class: "title" }

import DxColorBox from "devextreme-vue/color-box";
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { FieldSize } from "@/enums/system/FieldSize";
import { ColorWin32ToRGB } from "bright-logic-core/src/colours";
import { hexToWin32Color, rgbToWin32 } from "@/utils/colours/ColourConverter";


export default /*#__PURE__*/_defineComponent({
  __name: 'colour-picker',
  props: {
  /**
   * The numeric value used with `v-model` to bind the component state. This typically represents an ID or a selected value.
   * @type {number}
   * @required
   */
  modelValue: {
    type: Number,
    required: true,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * Determines whether the specific control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Emitted when the `modelValue` is updated, typically triggered when a selection changes.
   * @event update:modelValue
   * @param {Number} value - The new value to be updated in the model.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const colour = computed({
  get: () => props.modelValue,
  set: (value: number) => emit("update:modelValue", value),
});

const htmlColor = ref("");
const loading = ref(false);

onMounted(() => {
  setHtmlColor();
});

watch(
  () => props.modelValue,
  () => setHtmlColor(),
);

const setHtmlColor = () => {
  loading.value = true;
  htmlColor.value = ColorWin32ToRGB(Number(colour.value));

  /* Need to call nextTick before setting loading to false.
   * Otherwise, the watches on colors trigger prematurely */
  nextTick();
  loading.value = false;
};

watch(
  () => htmlColor.value,
  () => {
    if (!htmlColor.value || loading.value) {
      return;
    }

    // Need to account for users entering hex or rgb values
    let win32Color = hexToWin32Color(htmlColor.value);

    if (!win32Color) {
      win32Color = rgbToWin32(htmlColor.value);
    }

    if (win32Color) {
      colour.value = parseInt(win32Color);
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(props.label), 1),
    _createVNode(_unref(DxColorBox), {
      value: htmlColor.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((htmlColor).value = $event)),
      "read-only": props.readOnly,
      "accept-custom-value": true,
      width: _unref(FieldSize).XXSmall
    }, null, 8, ["value", "read-only", "width"])
  ]))
}
}

})